import {
    module01,
    module02,
    module03,
    module04,
    module05,
    module06,
    module07,
    module08,
    module09,
    module10,
    module11,
    module12,
    module13,
    module14,
    module15,
    module16,
    module17,
    module18,
    module19,
    module20,
    module21,
    module22,
    module23,
    module24,
    module25,
    module26,
    module27,
    module28,
    module29,
    module30,
    module31,
    module32,
    module33,
    module34,
    module35,
    module36,
    module37,
    module38,
    module39,
    module40,
    module41,
    module42,
    module43,
    module44,
    module45,
    module46,
    module47,
    module48,
    module49,
    module50,
    module51,
    module52,
    module53,
    module54,
    module55,
    module56,
    module57,
    module58,
    module59,
    module60,
    module61,
    module62,
    module63,
    module64,
    module65,
    module66,
    module67
} from "./modules.js";

export const routes = [
    { path: "/class/2/ukrmova/zah/modules/module01", module: module01 },
    { path: "/class/2/ukrmova/zah/modules/module02", module: module02 },
    { path: "/class/2/ukrmova/zah/modules/module03", module: module03 },
    { path: "/class/2/ukrmova/zah/modules/module04", module: module04 },
    { path: "/class/2/ukrmova/zah/modules/module05", module: module05 },
    { path: "/class/2/ukrmova/zah/modules/module06", module: module06 },
    { path: "/class/2/ukrmova/zah/modules/module07", module: module07 },
    { path: "/class/2/ukrmova/zah/modules/module08", module: module08 },
    { path: "/class/2/ukrmova/zah/modules/module09", module: module09 },
    { path: "/class/2/ukrmova/zah/modules/module10", module: module10 },
    { path: "/class/2/ukrmova/zah/modules/module11", module: module11 },
    { path: "/class/2/ukrmova/zah/modules/module12", module: module12 },
    { path: "/class/2/ukrmova/zah/modules/module13", module: module13 },
    { path: "/class/2/ukrmova/zah/modules/module14", module: module14 },
    { path: "/class/2/ukrmova/zah/modules/module15", module: module15 },
    { path: "/class/2/ukrmova/zah/modules/module16", module: module16 },
    { path: "/class/2/ukrmova/zah/modules/module17", module: module17 },
    { path: "/class/2/ukrmova/zah/modules/module18", module: module18 },
    { path: "/class/2/ukrmova/zah/modules/module19", module: module19 },
    { path: "/class/2/ukrmova/zah/modules/module20", module: module20 },
    { path: "/class/2/ukrmova/zah/modules/module21", module: module21 },
    { path: "/class/2/ukrmova/zah/modules/module22", module: module22 },
    { path: "/class/2/ukrmova/zah/modules/module23", module: module23 },
    { path: "/class/2/ukrmova/zah/modules/module24", module: module24 },
    { path: "/class/2/ukrmova/zah/modules/module25", module: module25 },
    { path: "/class/2/ukrmova/zah/modules/module26", module: module26 },
    { path: "/class/2/ukrmova/zah/modules/module27", module: module27 },
    { path: "/class/2/ukrmova/zah/modules/module28", module: module28 },
    { path: "/class/2/ukrmova/zah/modules/module29", module: module29 },
    { path: "/class/2/ukrmova/zah/modules/module30", module: module30 },
    { path: "/class/2/ukrmova/zah/modules/module31", module: module31 },
    { path: "/class/2/ukrmova/zah/modules/module32", module: module32 },
    { path: "/class/2/ukrmova/zah/modules/module33", module: module33 },
    { path: "/class/2/ukrmova/zah/modules/module34", module: module34 },
    { path: "/class/2/ukrmova/zah/modules/module35", module: module35 },
    { path: "/class/2/ukrmova/zah/modules/module36", module: module36 },
    { path: "/class/2/ukrmova/zah/modules/module37", module: module37 },
    { path: "/class/2/ukrmova/zah/modules/module38", module: module38 },
    { path: "/class/2/ukrmova/zah/modules/module39", module: module39 },
    { path: "/class/2/ukrmova/zah/modules/module40", module: module40 },
    { path: "/class/2/ukrmova/zah/modules/module41", module: module41 },
    { path: "/class/2/ukrmova/zah/modules/module42", module: module42 },
    { path: "/class/2/ukrmova/zah/modules/module43", module: module43 },
    { path: "/class/2/ukrmova/zah/modules/module44", module: module44 },
    { path: "/class/2/ukrmova/zah/modules/module45", module: module45 },
    { path: "/class/2/ukrmova/zah/modules/module46", module: module46 },
    { path: "/class/2/ukrmova/zah/modules/module47", module: module47 },
    { path: "/class/2/ukrmova/zah/modules/module48", module: module48 },
    { path: "/class/2/ukrmova/zah/modules/module49", module: module49 },
    { path: "/class/2/ukrmova/zah/modules/module50", module: module50 },
    { path: "/class/2/ukrmova/zah/modules/module51", module: module51 },
    { path: "/class/2/ukrmova/zah/modules/module52", module: module52 },
    { path: "/class/2/ukrmova/zah/modules/module53", module: module53 },
    { path: "/class/2/ukrmova/zah/modules/module54", module: module54 },
    { path: "/class/2/ukrmova/zah/modules/module55", module: module55 },
    { path: "/class/2/ukrmova/zah/modules/module56", module: module56 },
    { path: "/class/2/ukrmova/zah/modules/module57", module: module57 },
    { path: "/class/2/ukrmova/zah/modules/module58", module: module58 },
    { path: "/class/2/ukrmova/zah/modules/module59", module: module59 },
    { path: "/class/2/ukrmova/zah/modules/module60", module: module60 },
    { path: "/class/2/ukrmova/zah/modules/module61", module: module61 },
    { path: "/class/2/ukrmova/zah/modules/module62", module: module62 },
    { path: "/class/2/ukrmova/zah/modules/module63", module: module63 },
    { path: "/class/2/ukrmova/zah/modules/module64", module: module64 },
    { path: "/class/2/ukrmova/zah/modules/module65", module: module65 },
    { path: "/class/2/ukrmova/zah/modules/module66", module: module66 },
    { path: "/class/2/ukrmova/zah/modules/module67", module: module67 },
];